module.exports = __webpack_public_path__ + "static/media/V-ID-9.000c9f4e.mp4";